import {
	FilteredNode,
	FilteredParentNode,
	LocalizedLeafNode,
	LocalizedNode,
	LocalizedParentNode,
	Node,
	ParentNode
} from "src/modules/shared/form-explorer/types";

export function isRawParentNode(node: Node): node is ParentNode {
	return "children" in node;
}

export function isLocalizedParentNode(
	node: LocalizedNode
): node is LocalizedParentNode {
	return "children" in node;
}

export function isLocalizedLeafNode(
	node: LocalizedNode
): node is LocalizedLeafNode {
	return !("children" in node);
}

export function isFilteredParentNode(
	node: FilteredNode
): node is FilteredParentNode {
	return "children" in node;
}
